<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-05 15:25:51
 * @Description: 账号安全 账号设置 邮箱
-->
<template>
	<div class="set_email">
		<Head :title="$t('home.account_set.email')" />

		<a-form-model :model="form" :rules="rules" ref="form" :wrapper-col="{ span: 16, offset: 4 }">
			<a-form-model-item label="" prop="email">
				<a-input v-model="form.email" :placeholder="$t('base.email.placeholder')" />
			</a-form-model-item>
			<a-form-model-item label="" prop="code" class="flex">
				<a-input v-model="form.code" :placeholder="$t('base.captcha.placeholder')" />
				<div class="codeBox">
					<a-button v-if="count == 60" type="primary" @click="handleCode">{{ $t("base.btn.get_code") }}</a-button>
					<a-button type="primary" disabled v-else>{{ count }}s</a-button>
				</div>
			</a-form-model-item>
		</a-form-model>
	</div>
</template>

<script>
import Head from "./components/Head";
import { commonAPI } from "@/apis";

export default {
	components: { Head },
	props: {
		selfEmail: { type: String, default: "" },
	},
	data() {
		return {
			form: { email: "", code: "" },
			rules: {
				email: [
					{ required: true, message: this.$t("base.email.placeholder") },
					{ pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/, message: this.$t("base.email.error_tip") },
				],
				code: [{ required: true, message: this.$t("base.captcha.placeholder") }],
			},
			count: 60,
		};
	},
	created() {
		this.form.email = this.selfEmail;
	},
	methods: {
		// 获取验证码
		handleCode() {
			this.$refs.form.validateField("email", (message) => {
				if (!message) {
					let params = { noticeClassify: 1, businessClassify: "change_phone_email", account: this.form.email };
					this.handleVerify(params);
				} else {
					return false;
				}
			});
		},
		async handleVerify(params) {
			const { code, message } = await commonAPI.postAction("/send/msg/bindEmail", params);
			if (code == 0) {
				this.$message.success(message);
				// 开启倒计时
				this.count--;
				const timer = setInterval(() => {
					if (this.count > 0 && this.count <= 60) {
						this.count--;
					} else {
						this.count = 60;
						clearInterval(timer);
					}
				}, 1000);
			} else {
				this.$message.error(message);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.set_email::v-deep {
	.flex .ant-form-item-children {
		display: flex;
		align-items: center;

		.codeBox {
			width: 100px;
			margin-left: 12px;
			& > * {
				width: 100%;
			}
		}
	}
}
</style>
